<template>
	<div class="check_policy">
		<v-checkbox @change="checkToggle" color="#4B5EFF" v-model="check_policy"></v-checkbox>
		<div class="check_policy_text">
			Я полностью соглашаюсь с условиями <a target="_blank" :href="`https://${$baseDomain}/liczenzionnoe-soglashenie-2/`">Лицензии</a> и даю
			согласие на обработку своих персональных данных в соответствии с <a target="_blank"
				:href="`https://${$baseDomain}/politika-konfidenczialnosti/`">Политикой</a>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			check_policy: this.$store.getters['user/getPolicy']
		}
	},
	methods: {
		checkToggle() {
			let status = this.$store.getters['user/getPolicy']
			this.$store.commit('user/setPolicy', !status)
		}
	}
}
</script>
<style scoped>
.check_policy {
    display: flex;
	margin-top: 12px;
}

.check_policy_text {
    text-align: left;
    font-family: 'Manrope';
    font-size: 12px;
    line-height: 140%;
    font-weight: 500;
    color: #808185;
}
</style>
